




































import { Component, Vue, Prop } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import { SurveySingleSelectOptions } from '@/models/survey-elements/single-select-options';
import { SurveySelectOptionPayload } from '@/models/survey-elements/select-option-payload';
import TextField from '@/components/TextField.vue';
import SingleSelectItem from '@/components/SingleSelectItem.vue';
import SingleSelectGroup from '@/components/SingleSelectGroup.vue';
import { EventBus } from '@/event-bus';
import { SurveySingleSelectElement } from '@/models/survey-elements/single-select-element';
import { WIDGET_EVENTS } from '@/const/widget-events';
import { SINGLE_SELECT_TYPE } from '@/models/enums/single-select-type';
import { ANALYTICS_EVENTS } from '@/const/analytics-events';

@Component({
  name: 'single-select-widget',
  components: {
    Header,
    TextField,
    SingleSelectItem,
    SingleSelectGroup,
    ButtonElement: () => import('@/components/widgets/ButtonElement.vue'),
  },
})
export default class SingleSelectWidget extends Vue {
  @Prop({ type: String }) externalApiIdentifier!: string | null;
  @Prop({ type: Object }) value!: SurveySingleSelectOptions;
  @Prop({ type: Array, required: true }) options!: SurveySingleSelectOptions[];
  @Prop({ type: String }) title?: string;
  @Prop({ type: Number, required: true }) type!: SINGLE_SELECT_TYPE;
  @Prop({ type: Object }) field?: SurveySingleSelectElement;

  private localValue: SurveySelectOptionPayload = this.value;
  private singleSelectType = SINGLE_SELECT_TYPE;
  private showAdditionalField = false;
  private localOptions = { ...this.options };
  private get selectedValue() {
    return this.localValue && this.localValue.value;
  }

  created() {
    if (!this.externalApiIdentifier) return;
    const externalApiIdentifier = this.$route.query[this.externalApiIdentifier];
    if (externalApiIdentifier) {
      const preselectedOption = this.options.find(
        option => `${option.value}` == externalApiIdentifier
      );
      if (!preselectedOption) return;
      const { value, label } = preselectedOption;
      this.localValue = {
        value,
        label,
      };

      this.changeEvent(this.localValue);
    }
  }

  private get isClassicRadio() {
    return [
      SINGLE_SELECT_TYPE.RADIO,
      SINGLE_SELECT_TYPE.RADIO_VERTICAL,
    ].includes(this.type);
  }

  private changeEvent(value: SurveySelectOptionPayload) {
    EventBus.$emit(WIDGET_EVENTS.CHANGE, {
      field: this.field,
      value: !value?.label ? null : value,
    });
  }

  onChangeHandler(value: SurveySingleSelectOptions) {
    this.changeEvent(value);
  }
  onCustomValueChangeHandler(value: SurveySingleSelectOptions) {
    this.localValue = value;
    this.changeEvent({
      label: null,
      value: value.value,
      allowCustomValue: true,
    });
  }

  onButtonClickHandler(value: SurveySingleSelectOptions) {
    EventBus.$emit(WIDGET_EVENTS.SUBMIT, { field: this.field, value });
  }
}
